/**
 * Review slider: shows one review at a time in a scroll-snap track.
 * Visitors swipe the track or use the previous/next buttons.
 * Markup: [data-track] scroll container, [data-prev] and [data-next] buttons.
 */
class ReviewSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    if (!this.track) return;

    this.onPrev = () => this.go(-1);
    this.onNext = () => this.go(1);
    this.onScroll = () => this.update();

    this.prevButton?.addEventListener('click', this.onPrev);
    this.nextButton?.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.onPrev);
    this.nextButton?.removeEventListener('click', this.onNext);
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  go(direction) {
    const isRtl = getComputedStyle(this.track).direction === 'rtl';
    const step = this.track.clientWidth * direction * (isRtl ? -1 : 1);
    this.track.scrollBy({ left: step, behavior: 'smooth' });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const position = Math.abs(this.track.scrollLeft);
    if (this.prevButton) this.prevButton.disabled = position <= 2;
    if (this.nextButton) this.nextButton.disabled = position >= max - 2;
  }
}

if (!customElements.get('s-review-slider')) {
  customElements.define('s-review-slider', ReviewSlider);
}
